import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import StorageIcon from '@mui/icons-material/Storage';
import { Box, Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const apps = [
  {
    key: 'database',
    label: 'Database',
    description: 'Browse and manage the battery technology database - suppliers, cell types, products, and solutions.',
    icon: <StorageIcon sx={{ fontSize: 48, color: '#009DE0' }} />,
    path: '/database/entities/suppliers',
  },
  {
    key: 'comparator',
    label: 'Comparator',
    description: 'Compare cell types and cell products side-by-side on key performance metrics.',
    icon: <CompareArrowsIcon sx={{ fontSize: 48, color: '#009DE0' }} />,
    path: '/comparator',
  },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
        bgcolor: '#F5F7FA',
        p: 4,
      }}
    >
      <Stack spacing={4} sx={{ alignItems: 'center' }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#002A5C' }}>
          Welcome to TechnoDB
        </Typography>
        <Typography variant="body1" sx={{ color: '#5C6B7A', maxWidth: 500, textAlign: 'center' }}>
          Choose an application to get started.
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
          {apps.map((app) => (
            <Card
              key={app.key}
              sx={{
                width: 300,
                borderRadius: 3,
                boxShadow: '0 2px 12px rgba(0,42,92,0.10)',
                transition: 'transform 150ms ease, box-shadow 150ms ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 24px rgba(0,42,92,0.18)',
                },
              }}
            >
              <CardActionArea onClick={() => navigate(app.path)} sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', py: 5, px: 3 }}>
                  {app.icon}
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 700, color: '#002A5C' }}>
                    {app.label}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, color: '#5C6B7A' }}>
                    {app.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default Home;
